import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import UserAdjustmentsValidatorClassicBuilder from './user-adjustments-validator-classic-builder';
import UserAdjustmentsValidatorTiersBuilder from './user-adjustments-validator-tiers-builder';
import UserAdjustmentsValidatorShowdownBuilder from './user-adjustments-validator-showdown-builder';
import EditedLineupValidatorClassicBuilder from './edited-lineup-validator-classic-builder';
import EditedLineupValidatorShowdownBuilder from './edited-lineup-validator-showdown-builder';
import EditedLineupValidatorTiersBuilder from './edited-lineup-validator-tiers-builder';

const userAdjustmentsValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: UserAdjustmentsValidatorClassicBuilder,
    [Const.GAME_TYPE_SHOWDOWN]: UserAdjustmentsValidatorShowdownBuilder,
    [Const.GAME_TYPE_TIERS]: UserAdjustmentsValidatorTiersBuilder,
};

export class UserAdjustmentsValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in userAdjustmentsValidatorClassesMap) {
            return new userAdjustmentsValidatorClassesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

const editedLineupValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: EditedLineupValidatorClassicBuilder,
    [Const.GAME_TYPE_SHOWDOWN]: EditedLineupValidatorShowdownBuilder,
    [Const.GAME_TYPE_TIERS]: EditedLineupValidatorTiersBuilder,
};

export class EditedLineupValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in editedLineupValidatorClassesMap) {
            return new editedLineupValidatorClassesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}
